import { TOGGLE_SIDE_NAV } from './types';

export default {
  async [TOGGLE_SIDE_NAV]({ commit }) {
    commit(TOGGLE_SIDE_NAV);
  }
};
